var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v(
          "Does your work contribute to Africa's Sustainable Development?"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Asoko Insight and United Nations Development Programme (UNDP) have partnered to identify and publically recognise companies across Africa that contribute to the infrastructure, equality and all aspects that support the Sustainable Development Goals (SDG).\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openProposals },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }